export default "/images/account_holder.png?a9adeb2a37d8965e24301997458d97ff";